import { Table, TableMetadata, useTable } from "@king-ict/eupisi-ui/components";
import type { TFunction } from "i18next";

import type { Competence } from "../../../models/ProgramRequest";
import styles from "../ProgramRequestEdit.module.scss";

interface IProps {
  t: TFunction;
  competences: Competence[];
}

export function ReadOnlyCompetencesTable({ t, competences }: IProps) {
  const programRequestCompetencesTableMetadata: TableMetadata<Competence> = {
    rowKey: "name",
    columns: [
      {
        columnKey: "programRequestCompetence",
        header: t("request.competenceName"),
        accessor: (item: Competence) => (
          <div className={styles.readOnlyCompetence}>{item.name}</div>
        ),
      },
    ],
    rowToolTip: () => undefined,
  };

  const [tableProps] = useTable<string>({
    metadata: programRequestCompetencesTableMetadata,
    data: competences,
    pagination: false,
    totalItems: competences.length,
  });

  return <Table {...tableProps} />;
}

